import { IsortTypeOptionItem } from '../../Shared/SortingContainer/SortingContainer.type';

export const sortTypeOptions: IsortTypeOptionItem[] = [
  {
    slug: 'newLoad',
    title: 'New',
    hide: false,
  },
  {
    slug: 'pickUpStartDate',
    title: 'Pick-up date',
    hide: false,
  },
  {
    slug: 'total_distance',
    title: 'Distance',
    hide: false,
  },
  {
    slug: 'ratePerMile',
    title: 'Loaded RPM',
    hide: false,
  },
  {
    slug: 'EstTotalRPM',
    title: 'Est Total RPM',
    hide: false,
  },
  {
    slug: 'price',
    title: 'Rate',
    hide: false,
  },
  {
    slug: 'originDeadHead',
    title: 'Origin Empty',
    hide: false,
  },
  {
    slug: 'destinationDeadHead',
    title: 'Destination Empty',
    hide: false,
  },
];
